import { AR } from './ar.js';

export type Lang = 'en' | 'ar';

export type Translate = (s: string) => string;

export function createTranslate(lang: Lang): Translate {
  if (lang !== 'ar') return (s) => s;
  return (s) => AR[s] ?? s;
}

export function isRtl(lang: Lang): boolean {
  return lang === 'ar';
}
